/**
 * @generated SignedSource<<10d012636f7deff5a44124679bed9b35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entityLink$data = {
  readonly __typename: string;
  readonly application: {
    readonly entityId: string;
  } | null;
  readonly entityId: string;
  readonly entityUuid: string;
  readonly urlAlias: string;
  readonly urlRedirect: {
    readonly toUrl: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarThemeArticle">;
  readonly " $fragmentType": "entityLink";
};
export type entityLink$key = {
  readonly " $data"?: entityLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "entityLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UrlRedirect",
      "kind": "LinkedField",
      "name": "urlRedirect",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Application",
      "kind": "LinkedField",
      "name": "application",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersAppBarThemeArticle",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sponsorType",
              "storageKey": null
            },
            {
              "alias": "articleTypes",
              "args": null,
              "concreteType": "ArticleTypeSegment",
              "kind": "LinkedField",
              "name": "types",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArticleType",
                  "kind": "LinkedField",
                  "name": "value",
                  "plural": true,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Base",
  "abstractKey": "__isBase"
};
})();

(node as any).hash = "a0e363b93ece53a57fee6f8d6a405c8b";

export default node;
